import {makeKey,update} from '../../../../utils/reducerOperations';
export function fetchSurveyTableStarted(state, payload) {
    return makeKey(
        'fetchSurveyTableApi',
        update(state.fetchSurveyTableApi, {
            isProcessing: true
        })
    );
}